import { ApiRequest, GetBaseServiceFunctions } from '../baseService'

const BaseRoute = 'app/file-manager'
const baseFunctions = GetBaseServiceFunctions(BaseRoute)

function SetFileSizeLimit(tenantId: string, fileSizeLimit: number) {
  return ApiRequest.post(`${BaseRoute}/${tenantId}/setFileSizeLimit`, {
    maxFileSizeInMB: fileSizeLimit,
  })
}

function CleanupRemovedFiles() {
  return ApiRequest.post(`${BaseRoute}/cleanupRemovedFiles`)
}

function GetTotalSize(tenantId: string) {
  return ApiRequest.get(`${BaseRoute}/${tenantId}/getTotalSize`)
}

export default {
  ...baseFunctions,
  SetFileSizeLimit,
  CleanupRemovedFiles,
  GetTotalSize,
}
